<template>
  <div>
    <b-card class="art_card" @click="clicked_art(art_json.id)">
      <div class="overlay_onTop">
        <div class="text">Experience in 3D</div>
      </div>
      <div class="data_body">
        <p class="artist_name">{{ art_json.artist.pen_name }}'s</p>
        <b-row class="flex" style="margin: 0.5px">
          <h4 class="artwork_name">{{ art_json.product_title }}</h4>
          <!-- <p v-if="art_json.is_original" class="ml-auto original_tag">
            Original
          </p> -->
        </b-row>
        <div
          class="thumb"
          v-bind:style="{ 'background-image': 'url(' + image + ')' }"
        ></div>

        <!-- <b-img-lazy fluid rounded  class="thumb" :src="art_json.product_image[0].thumbnail_image"   ></b-img-lazy> -->

        <b-row class="flex" style="margin: -15px 0px">
          <p class="ml-auto price_tag">
            INR
            {{ representInThousandsFormat(parseInt(art_json.selling_price)) }}
          </p>
        </b-row>
        <p class="bio">{{ art_json.product_description }}</p>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "TheArtCard",
  props: [
    // "id",
    // "artist_name",
    // "art_name",
    // "art_url",
    "art_json",
  ],
  data() {
    return {
      image: "",
      imageUrl: "",
    };
  },
  mounted: function () {
    this.setImage();
  },
  methods: {
    clicked_art(product_id) {
      let navigateBackTo = this.$store.state.navigateBackTo;
      navigateBackTo.required = true;
      navigateBackTo.url = this.$router.currentRoute.fullPath;
      navigateBackTo.metaInfo = {};

      // this.$router.push({name: "ThreeD", params : {gallery_type : "product", product_id : id}})
      this.$router.push(`/three-d?product=${product_id}`);
    },
    setImage() {
      this.imageUrl = this.art_json.product_image[0].thumbnail_image;
      this.image = "";
      var that;
      var highResImage = new Image();
      that = this;
      highResImage.onload = function () {
        that.image = that.imageUrl;
      };
      highResImage.src = this.imageUrl;
    },
  },
  computed: {
    getProductImage() {
      return this.art_json.product_image[0].thumbnail_image;
    },
  },
};
</script>

<style scoped>
.thumb {
  display: inline-block;
  width: 250px;
  height: 250px;
  background: center;
  background-size: cover;

  /* border-width: 1px !important;
    border-image-source: url("~@/assets/images/frame.png") 92 round;
    border-image-outset: 15px;
    border-image-slice: 40;
    border-image-width: 15px;
    border-image-repeat: stretch stretch; */
}

.text {
  overflow: visible;
  white-space: nowrap;
  line-height: 22px;
  text-align: center;
  font-family: "Titillium Web", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  color: rgba(12, 15, 102, 1);
  transition: 0.3s ease;
}

.data_body:hover {
  opacity: 0.2;
}

.art_card {
  cursor: pointer;
  border: none;
  flex-grow: 1;
  overflow: hidden;
}

.art_card:hover {
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
  transition: 0.3s ease;
}

.art_card:hover .overlay_onTop {
  opacity: 1;
}

.artwork_name {
  overflow: visible;
  white-space: nowrap;
  text-align: left;
  font-family: "Titillium Web", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  color: rgba(12, 15, 102, 1);
}
.artist_name {
  overflow: visible;
  white-space: nowrap;
  line-height: 22px;
  text-align: left;
  font-family: "Titillium Web", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  color: rgba(12, 15, 102, 1);
  margin-bottom: 0px;
}

.art_image {
  width: 50%;
  height: 50%;
  overflow: hidden;
  object-fit: cover;
}

.overlay_onTop {
  position: absolute;
  left: 50%;
  top: 50%;
  transition: 0.5s ease;
  opacity: 0;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.original_tag {
  position: relative;
  bottom: -20px;
  right: -30px;
  margin: 5px 0px;
  padding: 5px 20px;
  font-size: 12px;
  opacity: 1;
  background-color: rgba(12, 15, 102, 1);
  color: white;
  font-family: "Titillium Web", sans-serif;
  font-style: normal;
  font-weight: bold;
}

.price_tag {
  position: relative;
  right: -30px;
  padding: 5px 10px;
  font-size: 12px;
  opacity: 1;
  color: rgba(12, 15, 102, 1);
  background-color: whitesmoke;
  font-family: "Titillium Web", sans-serif;
  font-style: normal;
  font-weight: bold;
}

.bio {
  overflow: hidden;
  text-align: left;
  font-family: "Titillium Web", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: rgba(12, 15, 102, 1);
  overflow: hidden;
  text-align: justify;
  text-justify: inter-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>